
function Seperator() {
	return (<div className=" w-full h-0 m-0 mx-auto p-0 border-b border-border" />);
}

export default Seperator;